export default __webpack_public_path__ + "static/media/warningIcon.2d1cd6ec.svg";